<template>
  <div class="layout-footer">
    <div class="footer">
      <div class="row">
        <a
          :style="{ color: item.text === '会员服务' && '#FF0000' }"
          :key="key"
          class="entrance"
          :href="item.url"
          target="_blank"
          v-for="(item, key) in FOOTER.ENTRANCES"
        >
          {{ item.text }}
        </a>
      </div>
      <div class="row">
        <span
          >©版权所有 2008-{{ current_year }} 千里马招标网 www.qianlima.com
        </span>
        <a
          :href="FOOTER.ICP_RECORD.url"
          target="_blank"
          style="margin-left: 5px"
          >{{ FOOTER.ICP_RECORD.text }}</a
        >
      </div>
      <div class="row">
        <a
          style="color: #939393"
          :href="FOOTER.PUBLIC_RECORD.url"
          target="_blank"
          ><img :src="FOOTER.PUBLIC_RECORD.img" alt="public" />{{
            FOOTER.PUBLIC_RECORD.text
          }}</a
        >
      </div>
      <div class="row">
        <a :href="FOOTER.REPORT.url" target="_blank">
          <img :src="FOOTER.REPORT.img" alt="report" />
        </a>
        <a :href="FOOTER.POLICE.url" target="_blank" style="margin-left: 10px">
          <img :src="FOOTER.POLICE.img" alt="police" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { FOOTER } from "@/utils/constants/constants";

export default {
  name: "LayoutFooter",
  data() {
    return {
      FOOTER,
      current_year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/config.scss";

.layout-footer {
  width: 100%;
  margin-top: 50px;
  border-top: 2px solid #c5021b;

  .footer {
    width: $layout-body-width;
    margin: 0 auto;
    font-size: 12px;

    .row {
      display: flex;
      justify-content: center;
      margin: 22px 0;

      .entrance {
        width: 85px;
        text-align: center;
        border-right: 1px #333 dashed;
        line-height: 12px;

        &:last-child {
          border-right: none;
        }
      }
    }
  }
}
</style>
